import { chaveStatusProducaoItem } from "../constants/status";
import { IResultadoFinalizacaoSenatran } from "../interfaces/IAcoesLote";
import { IItemLote } from "../interfaces/IItemLote";

const PRODUCAO_ELEGIVEL = ["ESTAMPADO", "FALHA_SENATRAN"];

export function elegivelParaFinalizarSenatran({
  statusProducao,
}: Pick<IItemLote, "statusProducao">): boolean {
  return (
    statusProducao !== null &&
    PRODUCAO_ELEGIVEL.includes(chaveStatusProducaoItem(statusProducao))
  );
}

export function nadaFinalizado({
  finalizadas,
  falhas,
}: IResultadoFinalizacaoSenatran): boolean {
  return finalizadas + falhas === 0;
}

export function algumaFinalizada({
  finalizadas,
}: IResultadoFinalizacaoSenatran): boolean {
  return finalizadas > 0;
}
